<template>
  <div class="youtube-box ratio-169-container" v-show="newVideoUrl && displayHighlights">
    
    <iframe :src="newVideoUrl" 
      class="youtube-frame ratio-169-content"
      v-if="isNormalVideo && displayHighlights"
      allow="fullscreen" />

    <div class="youtube-box2 ratio-169-content"
      v-show="youtubeEnable && !isNormalVideo"
        id="youtube-box2-app" >
        <div ref="youtubePlayerApp" class="youtube-frame"></div>
      </div>

    <DefaultHighLightUi v-show="!youtubeEnable && !isNormalVideo" :videoUrl="newVideoUrl" />
  </div>
  <div class="match-detail__header-wrapper">
    
    <!-- <div class="match-detail__header-info">
      <div class="match-detail__header-info__match" v-if="data.leagueName !== null">
        {{ data.leagueName }}
      </div>
      <div class="match-detail__header-info__country">{{ data.country }}</div>
    </div> -->
    <div
      class="match-detail__header-info__opponent"
      :class="{
        'display-flex-align-end': data.matchState > 0,
        'display-flex-align-center': data.matchState <= 0,
      }"
    >
      <Navigation
        :id="data.homeTeamId"
        :category="'team'"
        :name="data.homeTeamName"
        class="display-flex-sb"
      >
        <!-- <router-link  :to="{path:`/${currentLocale}/${currentSportType}/team/${data.homeTeamId}`}" class="display-flex-sb"> -->
        <div
          class="display-flex-center flex-col match-detail__team-info-wrapper"
        >
          <Icon
            :logoUrl="data.homeLogo"
            hasClass="match-detail-team-icon"
          ></Icon>
          <span
            class="penalty-compact-label right"
            v-if="
              data.homeTeamPenaltyScore &&
              data.homeTeamPenaltyScore > data.awayTeamPenaltyScore
            "
            >P</span
          >
          <!-- <div class="match-detail__header-info__penatly-label right">
            <img
              src="../../../static/images/label/label_short_pen_win.png"
              v-if="data.homeTeamPenaltyScore > data.awayTeamPenaltyScore"
            />
          </div> -->
          <div class="match-detail__header-info__home-name">
            {{ data.homeTeamName ? data.homeTeamName : "TBD" }}
          </div>
        </div>
      </Navigation>
      <!-- </router-link > -->

      <!-- Start: Match to be started / Canc. / Postponed etc. -->
      <!-- mr-1rem ml-1rem  -->
       
      <div
        v-if="data.matchState <= 0 && data.matchState !== -1"
        class="match-detail__header-info__score-wrapper future-match-time"
        :class="{ 
          'postp': data.matchStatus === 'Postp.',
          'score-wrapper-not-start': data.matchState === 0,
          'score-wrapper-not-today-tomorrow': checkIfTomorrow(data.matchTime) === ''
           }"
      >
        <div class="match-detail__header-secondary_info display-flex-center" v-if="checkIfTomorrow(data.matchTime)">
          {{ checkIfTomorrow(data.matchTime) }} 
        </div>
        <!--  && !manualRefreshMatchDetailScore -->
        <div class="display-flex-center" v-show="data.matchStatus">
          <!-- <div class="match-detail__header-info__score"> -->
          {{ data.matchStatus }}
          <!-- </div> -->
        </div>
        <!-- <div 
          class="display-flex-center skeleton-match-detail__wrapper"
          v-show="manualRefreshMatchDetailScore"
        >
          <div class="skeleton-child skeleton-match-detail__score"></div>
        </div> -->
      </div>
      <!-- End: Match to be started / Canc. / Postponed etc.  -->

      <!-- Start: Normal Match Progress -->
      <!-- mr-1rem ml-1rem  -->
      <div
        v-else-if="data.matchState > 0 || data.matchState === -1"
        class="match-detail__header-info__score-wrapper"
        :class="{
          'match-end-score': data.matchState < 0,
          'match-has-second-status': matchSecondaryStatus !== matchPrimaryStatus
        }"
      >
        <!--  && !data.matchStatus.includes(':') -->
        <!-- <div
          v-if="data.matchStatus"
          class="match-detail__header-info__match-status display-flex-center"
        >
          {{ matchPrimaryStatus }}
        </div> -->
        <!--  && !manualRefreshMatchDetailScore -->
        <span
          class="match-detail__header-secondary_info display-flex-center"
          v-show="currentSportType !== 'basketball'"
        >
          {{ matchPrimaryStatus }}
        </span>

        <div
          class="display-flex-center match-detail__header-info__score-container"
          v-show="homeTeamScore !== '' && awayTeamScore !== ''"
        >
          <div class="team-red-card-container">
            <div class="team-red-card" v-for="i in data.homeRed"></div>
          </div>
          <div
            :class="[
              homeTeamScore >= 100
                ? 'match-detail__header-info__score-100'
                : 'match-detail__header-info__score',
            ]"
          >
            {{ homeTeamScore }}
          </div>
          <!-- :class="{
              'match-detail__header-info__score-divider':
                homeTeamScore >= 100 || awayTeamScore >= 100,
            }" -->
          <div class="match-detail__header-info__score-divider px-8">-</div>
          <div
            :class="[
              awayTeamScore >= 100
                ? 'match-detail__header-info__score-100'
                : 'match-detail__header-info__score',
            ]"
          >
            {{ awayTeamScore }}
          </div>
          <div class="team-red-card-container">
              <div class="team-red-card" v-for="i in data.awayRed"></div>
            </div>
        </div>
        <!-- <div 
          class="display-flex-center skeleton-match-detail__wrapper"
          v-show="manualRefreshMatchDetailScore"
        >
          <div class="skeleton-child skeleton-match-detail__score"></div>
          <div>-</div>
          <div class="skeleton-child skeleton-match-detail__score"></div>
        </div> -->
        <div class="match-detail__status" v-if="matchSecondaryStatus !== matchPrimaryStatus">
          {{ matchSecondaryStatus }}
        </div>
      </div>
      <!-- End: Normal Match Progress -->

      <!-- <router-link  :to="{path:`/${currentLocale}/${currentSportType}/team/${data.awayTeamId}`}"  class="display-flex-sb"> -->
      <Navigation
        :id="data.awayTeamId"
        :category="'team'"
        :name="data.awayTeamName"
        class="display-flex-sb"
      >
        <div
          class="display-flex-center flex-col match-detail__team-info-wrapper"
        >
          <Icon
            :logoUrl="data.awayLogo"
            hasClass="match-detail-team-icon"
          ></Icon>
          <span
            class="penalty-compact-label left"
            v-if="
              data.homeTeamPenaltyScore &&
              data.awayTeamPenaltyScore > data.homeTeamPenaltyScore
            "
            >P</span
          >
          <!-- <div class="match-detail__header-info__penatly-label left">
            <img
              src="../../../static/images/label/label_short_pen_win.png"
              v-if="data.awayTeamPenaltyScore > data.homeTeamPenaltyScore"
            />
          </div> -->
          <div class="match-detail__header-info__away-name">
            {{ data.awayTeamName ? data.awayTeamName : "TBD" }}
          </div>
        </div>
        <!-- </router-link>    -->
      </Navigation>
    </div>
  </div>
  <!--  v-if="Object.keys(winRate).length > 0" -->
  <!-- <ScoreInfoWinRate :winRate="winRate" :detailOdds="detailOdds"></ScoreInfoWinRate> -->

  <div class="match-summary-container" v-if="matchSummary && matchSummary.homeGoalEvents && matchSummary.awayGoalEvents">
    <div class="goal-list"  v-if="data.matchState < 0 && matchSummary.homeGoalEvents.length !== 0 || matchSummary.awayGoalEvents.length !== 0">
      <div class="goal-item left">
        <div class="goal-child" v-for="(i,index) in matchSummary.homeGoalEvents">
          {{ i.playerName }} {{ i.eventMinute }}{{ i.extraMin ? ` + ${i.extraMin}'` : '\'' }}
        </div>
      </div>
      <IconMode>
        <template #default="{ index }">
          <img src="@static/images/icons/aspn_icon/match_info/football_webapp.png" v-if="['lightWeb','lightWebapp'].includes(index)" class="goal-icon" />
          <img src="@static/images/icons/aspn_icon/match_info/football_dark_webapp.png" v-else-if="['darkWeb','darkWebapp'].includes(index)" class="goal-icon" />
        </template>
      </IconMode>
      <div class="goal-item">
        <div class="goal-child" v-for="(i,index) in matchSummary.awayGoalEvents">
          {{ i.playerName }} {{ i.eventMinute }}{{ i.extraMin ? ` + ${i.extraMin}'` : '\'' }}
        </div>
      </div>
    </div>

    <div class="match-yellowred-list" v-if="hasRed && isShowYellowRed">
      <div class="match-yellowred-item left">
        <div v-for="(i,index) in matchScoreYellowRedList('red', 'home')" 
          class="match-yellowred-child">
          {{ i.playerName }} {{ i.eventMinute }}{{ i.extraMin ? ` + ${i.extraMin}'` : '\'' }}
        </div>
      </div>
      <div class="match__event-type redcard"></div>
      <div class="match-yellowred-item">
        <div v-for="(i,index) in matchScoreYellowRedList('red', 'away')" 
          class="match-yellowred-child">
          {{ i.playerName }} {{ i.eventMinute }}{{ i.extraMin ? ` + ${i.extraMin}'` : '\'' }}
        </div>
      </div>
    </div>
    
    <div class="match-yellowred-list" v-show="hasYellow && isShowYellowRed">
      <div class="match-yellowred-item left">
        <div v-for="(i,index) in matchScoreYellowRedList('yellow', 'home')" 
          class="match-yellowred-child">
          {{ i.playerName }} {{ i.eventMinute }}{{ i.extraMin ? ` + ${i.extraMin}'` : '\'' }}
        </div>
      </div>
      <div class="match__event-type yellowcard"></div>
      <div class="match-yellowred-item">
        <div v-for="(i,index) in matchScoreYellowRedList('yellow', 'away')" 
          class="match-yellowred-child">
          {{ i.playerName }} {{ i.eventMinute }}{{ i.extraMin ? ` + ${i.extraMin}'` : '\'' }}
          <!-- <div class="player__row--item--red-card"></div> -->
        </div>
      </div>
    </div>

    

    <div class="btn-view-all-card" 
      @click="isShowYellowRed = !isShowYellowRed" 
      v-if="hasYellowRed">
      {{ isShowYellowRed ? 
        $t('HIDE_ALL_CARD') :
        $t('VIEW_ALL_CARD') 
      }}
      <IconMode>
        <template #default="{ index }">
          <img src="@static/images/icons/icon_arrow_down_black.png" v-if="['lightWeb','lightWebapp'].includes(index)" class="arrow-icon"
            :class="{
              'show': isShowYellowRed
            }" />
          <img src="@static/images/icons/icon_arrow_down_white.png" v-else-if="['darkWeb','darkWebapp'].includes(index)" class="arrow-icon"
            :class="{
              'show': isShowYellowRed
            }" />
        </template>
      </IconMode>
    </div>

  </div>
</template>

<script>
import ScoreInfoWinRate from "@/components/matchDetail/ScoreInfoWinRate.vue";
import DefaultHighLightUi from '@/components/highlights/DefaultUi.vue'

import { mapGetters, mapActions } from "vuex";
import config from "@/js/config.js";

export default {
  components: {
    ScoreInfoWinRate,
    DefaultHighLightUi
  },
  props: {
    data: {
      type: Object,
    },
    winRate: {
      type: Object,
      default: {},
    },
    detailOdds: {
      type: Object,
    },
    displayHighlights: {
      type: Boolean
    }
  },

  computed: {
    ...mapGetters([
      "isMobileRealTime",
      "isMobile",
      "currentLocale",
      "currentSportType",
      "manualRefreshMatchDetailScore"
    ]),
    hasYellowRed() {
      if(this.matchSummary.homeYellowRedEvents && this.matchSummary.awayYellowRedEvents) {
        let homeList = this.matchSummary.homeYellowRedEvents
        let awayList = this.matchSummary.awayYellowRedEvents
        if(homeList.length === 0 && awayList.length === 0) {
          return false
        }
        return true
      }
    },
    hasYellow() {
      let home = this.matchScoreYellowRedList('yellow', 'home')
      let away = this.matchScoreYellowRedList('yellow', 'away')
      if(home.length === 0 && away.length === 0) {
        return false
      }
      return true      
    },
    hasRed() {
      let home = this.matchScoreYellowRedList('red', 'home')
      let away = this.matchScoreYellowRedList('red', 'away')
      if(home.length === 0 && away.length === 0) {
        return false
      }
      return true      
    }
  },
  watch: {
    data: {
      deep: true,
      handler(newVal, oldVal) {
        // this.dateFormat();
        this.updatePrimaryMatchStatus();
        this.updateSecondaryMatchStatus();
      },
    },
    isMobileRealTime(newVal) {
      if(!newVal) {
        this.getFullHighlightListData()
        this.checkYoutubeAvailable()
      }
    }
  },

  data() {
    return {
      matchDateDay: "",
      footballMatchStatusFullText: config.footballMatchStatusFullText,
      basketballMatchStatusFullText: config.basketballMatchStatusFullText,
      matchStatusShortHalfTime: "H.T.",
      matchStatusShortFullTime: "F.T.",
      matchStatusShortPenalty: "PEN", //Pen.
      matchStatusShortAET: "AET",
      matchStatusShortAGG: "AGG",
      matchPrimaryStatus: "",
      matchSecondaryStatus: "",
      homeTeamScore: "",
      awayTeamScore: "",

      fullHighlight: {},
      matchId: '',
      s3ImgUrl: config.s3ImgUrl,
      matchSummary: {},
      isShowYellowRed: false,
      youtubeEnable: false,
      newVideoUrl: "",
      newVideoId : "",
      player2: "",
      isNormalVideo: false,
      
    };
  },
  created() {
    this.matchId = this.$route.params.matchId
  },
  mounted() {
    //this.dateFormat();
    this.getSummaryData()
    // this.playVideoLive();
    if(this.isMobile) {

      this.getFullHighlightListData()
      // this.checkYoutubeAvailable()
    }
  },

  methods: {
    ...mapActions([
      'getMatchDetailScoreCard',
      'getFullHighlightList'
    ]),
    checkYoutubeAvailable() {
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
      
      let width = window.innerWidth
      let height = window.innerWidth * 9 / 16
      window.onYouTubeIframeAPIReady = (videoId) => {
        new YT.Player(this.$refs.youtubePlayerApp, {
          videoId: this.newVideoId,
          width: width,
          height: height,
          events: {
            onReady: this.onVideoReady,
            onError: this.onVideoError,
          }
        });
        // if(videoId) {
        // }
      };
    },
    onVideoReady(event) {
      // console.log('mobile-onready')
      this.youtubeEnable = true
      this.player2 = event.target
      this.$emit('youtubeEnableWebapp', this.youtubeEnable)
    },
    onVideoError(e) {
      // console.log('mobile-onerror', e.data)
      // 2 = Invalid parameter	请求中包含非法参数，例如 videoId 格式错误。
      // 5 =	HTML5 player error
      // 100 = Video not found 无效或视频被删除/设为私密。
      // 101 = Embedding not allowed 禁止视频嵌入到其他网站。
      // 150 = Embedding not allowed
      if([2,5,100,101,150].includes(e.data)) {
        this.youtubeEnable = false
        this.$emit('youtubeEnableWebapp', this.youtubeEnable)
      }
    },
    videoUrl() {
      if(this.fullHighlight.videoUrl) {
        
        const prefix = 'https://www.youtube.com/embed/'
        const youtubeRegex = /(?:youtube\.com|youtu\.be)/i;
          // this.fullHighlight.videoUrl = 'https://www.youtube.com/watch?v=FStlwCBMsJ8'
  
        if (!youtubeRegex.test(this.fullHighlight.videoUrl)) {
          this.youtubeEnable = true;
          this.newVideoUrl = this.fullHighlight.videoUrl
          this.isNormalVideo = true
          this.$emit('youtubeEnableWebapp', this.youtubeEnable)
          // return this.fullHighlight.videoUrl
        };
  
        try {
          const parsedUrl = new URL(this.fullHighlight.videoUrl);
  
          if (parsedUrl.hostname.includes('youtube.com')) {
            let id = parsedUrl.searchParams.get('v');
            this.newVideoUrl = this.fullHighlight.videoUrl
            this.newVideoId = id
            this.checkYoutubeAvailable()
            if(this.newVideoId) {
              
            window.onYouTubeIframeAPIReady(this.newVideoId)
            }
            // return prefix + id
          }
  
          // 如果是 youtu.be 短链接格式，取 pathname（去掉开头的 /）
          if (parsedUrl.hostname.includes('youtu.be')) {
            let id = parsedUrl.pathname.slice(1);
            // window.onYouTubeIframeAPIReady(id)
            this.newVideoUrl = this.fullHighlight.videoUrl
            this.newVideoId = id
            this.checkYoutubeAvailable()
            if(this.newVideoId) {
              
            window.onYouTubeIframeAPIReady(this.newVideoId)
            }
            // return prefix + id
          }
        } catch (e) {
          return null;
        }
      } else {
        return null
      }
      
    },
    playPlayer() {
      if(!this.isNormalVideo) {
        this.player2.playVideo();
      }
    },
    closePlayer() {
      if(!this.isNormalVideo) {
        this.player2.stopVideo();
      }
    },
    updateSportTypePrimaryMatchStatus(fullTextList) {
      let keysArr = Object.keys(fullTextList);
      if(this.data.containExtraTime) {
        this.matchPrimaryStatus = this.matchStatusShortAET
      } else if (this.data.matchStatus === "Pen.") {
        this.matchPrimaryStatus = fullTextList["FT"];
      } else if (keysArr.includes(this.data.matchStatus)) {
        if (["Q1", "Q2", "Q3", "Q4"].includes(this.data.matchStatus)) {
          this.matchPrimaryStatus = this.data.matchStatus;
          if (this.data.remainTime != "")
            this.matchPrimaryStatus += ` ${this.data.remainTime}'`;
        } else this.matchPrimaryStatus = fullTextList[this.data.matchStatus];
      } else {
        this.matchPrimaryStatus = this.data.matchStatus;
      }
    },
    updatePrimaryMatchStatus() {
      if (this.data.matchStatus) {
        if (this.currentSportType === "football") {
          this.updateSportTypePrimaryMatchStatus(
            this.footballMatchStatusFullText
          );
        } else if (this.currentSportType === "basketball") {
          this.updateSportTypePrimaryMatchStatus(
            this.basketballMatchStatusFullText
          );
        }
        /**
         * Football - Match State
         * only cover matchState 1,2,3,4,-1 here
         * 1 - 1st half match
         * 2 - Half Time
         * 3 - 2nd half match
         * 4 - Extra Time
         * 5 - Ongoing Penalty
         * -1 - End of match, 3 main scenarios
         */
        if (this.currentSportType === "football") {
          if ([1, 2, 3, 5, -1].includes(this.data.matchState)) {
            //this.data.matchState === 1
            if(this.data.containExtraTime) {
              this.homeTeamScore = this.data.homeTeamExtraTimeScore;
              this.awayTeamScore = this.data.awayTeamExtraTimeScore;
            } else {
              this.homeTeamScore = this.data.homeTeamScore;
              this.awayTeamScore = this.data.awayTeamScore;
            }
          } else if (this.data.matchState === 4) {
            this.homeTeamScore = this.data.homeTeamExtraTimeScore;
            this.awayTeamScore = this.data.awayTeamExtraTimeScore;
          }
        } else if (this.currentSportType === "basketball") {
          /** 
           * Basketball - Match State
            0：未开赛
            1：一节
            2：二节
            3：三节
            4：四节
            5：1'OT
            6：2'OT
            7：3'OT
            50：中场
            -1：完场
            -2：待定
            -3：中断
            -4：取消
            -5：推迟
          */
          if ([1, 2, 3, 4, 5, 6, 7, 50, -1].includes(this.data.matchState)) {
            this.homeTeamScore = this.data.homeTeamScore;
            this.awayTeamScore = this.data.awayTeamScore;
          }
        }
      }
    },
    updateSecondaryMatchStatus() {
      if (this.currentSportType === "football") {

        // // 2nd Half Time
        if (this.data.matchState === 3) {
          this.matchSecondaryStatus = `${this.matchStatusShortHalfTime} ${this.data.homeTeamHalfScore} - ${this.data.awayTeamHalfScore}`;
        } 
        
        else if (this.data.matchState === 4) {
          // Extra Time
          this.matchSecondaryStatus = `${this.matchStatusShortHalfTime} ${this.data.homeTeamHalfScore} - ${this.data.awayTeamHalfScore}`;
        } 
        
        else if (this.data.matchState === 5) {
          // Ongoing Penalty (temporary enabled)
          this.matchSecondaryStatus = `${this.matchStatusShortHalfTime} ${this.data.homeTeamHalfScore} - ${this.data.awayTeamHalfScore}`;
        } 
        
        else if (this.data.matchState === 5) {
          // Ongoing Penalty
          // with Extra Time
          if (this.data.containExtraTime === true) {
            this.matchSecondaryStatus = `${this.matchStatusShortHalfTime} ${this.data.homeTeamHalfScore} - ${this.data.awayTeamHalfScore}`;
          } 
          else {
            // without Extra Time
            this.matchSecondaryStatus = `${this.matchStatusShortHalfTime} ${this.data.homeTeamHalfScore} - ${this.data.awayTeamHalfScore}`;
          }
        } 
        
        else {
          if (this.data.matchState === -1) {
            // Full Time
            if(this.data.matchStatus === "AET") {
              this.matchSecondaryStatus = `${this.matchStatusShortHalfTime} ${this.data.homeTeamHalfScore} - ${this.data.awayTeamHalfScore}`;
            } else if (this.data.matchStatus === "FT") {
              // Normal Match End
              // this.matchSecondaryStatus = `${this.footballMatchStatusFullText["FT"]}`;
              this.matchSecondaryStatus = `${this.matchStatusShortHalfTime} ${this.data.homeTeamHalfScore} - ${this.data.awayTeamHalfScore}`;
              } else if (this.data.matchStatus === "AET") {
              //   // After Extra Time
                this.matchSecondaryStatus = `${this.matchStatusShortAET} ${this.data.homeTeamExtraTimeScore} - ${this.data.awayTeamExtraTimeScore}`;
            } else if (this.data.matchStatus === "Pen.") {
              // Penalty
              this.matchSecondaryStatus = `${this.matchStatusShortPenalty}: ${this.data.homeTeamPenaltyScore} - ${this.data.awayTeamPenaltyScore}`;
            }
          }
        }
      }
      // 26/01/2023 - BA (Julio) informed to remove "matchSecondaryStatus" element for basketball, as itis confusing
      //  else if (this.currentSportType === "basketball") {
      //   // Q2
      //   if (this.data.matchState === 2) {
      //     this.matchSecondaryStatus = `Q1. ${this.data.homeQ1Score} - ${this.data.awayQ1Score}`;
      //   } else if (this.data.matchState === 50) {
      //     // Half Time (Q2 ended)
      //     this.matchSecondaryStatus = `Q2. ${this.data.homeQ2Score} - ${this.data.awayQ2Score}`;
      //   } else if (this.data.matchState === 3) {
      //     // Q3
      //     this.matchSecondaryStatus = `${this.matchStatusShortHalfTime} ${this.data.homeHalfTimeScore} - ${this.data.awayHalfTimeScore}`;
      //   } else if (this.data.matchState === 4) {
      //     // Q4
      //     this.matchSecondaryStatus = `Q3. ${this.data.homeQ3Score} - ${this.data.awayQ3Score}`;
      //   } else if (this.data.matchState === -1) {
      //     // Full Time
      //     this.matchSecondaryStatus = `${this.matchStatusShortHalfTime} ${this.data.homeHalfTimeScore} - ${this.data.awayHalfTimeScore}`;
      //   } else if ([5,6,7].includes(this.data.matchState)) {
      //     // Overtime
      //     this.matchSecondaryStatus = `${this.matchStatusShortFullTime} ${this.data.homeHalfTimeScore} - ${this.data.awayHalfTimeScore}`;
      //   }
      //   // OT concluded???
      // }
    },
    // dateFormat() {
    //   if (typeof this.data !== "undefined") {
    //     if (typeof this.data.matchTime !== "undefined") {
    //       let result;
    //       let matchDate = new Date(this.data.matchTime);

    //       if (this.currentLocale === 'vn') {
    //         result =
    //           `${this.$i18n.t(this.$tools.getFullDay(matchDate.getDay()))},
    //            ${matchDate.getDate()} tháng ${matchDate.getMonth() + 1} năm
    //            ${matchDate.getFullYear()},
    //            ${matchDate.getHours()} giờ
    //            ${(matchDate.getMinutes() < 10 ? "0": "") + matchDate.getMinutes()} phút`;
    //       } else {
    //           result =
    //             `${this.$i18n.t(this.$tools.getDay(matchDate.getDay()) )},
    //              ${matchDate.getDate()}
    //              ${this.$i18n.t(this.$tools.getMonth(matchDate.getMonth()))}
    //              ${matchDate.getFullYear()},
    //              ${(matchDate.getHours() < 10? "0" : "") + matchDate.getHours()}:
    //              ${(matchDate.getMinutes() < 10 ? "0" : "") + matchDate.getMinutes()}
    //             `;
    //       }
    //      return result;
    //     }
    //   }
    // },
    async getFullHighlightListData() {
      const result = await this.getFullHighlightList({
        matchId: this.matchId
      })
      if(result.errorCode === 0) {
        if(result.result[0]) {
          this.fullHighlight = result.result[0]
          if(this.isMobile) {
            this.videoUrl()
          }
        }
      }
    },
    async getSummaryData() {
      const result = await this.getMatchDetailScoreCard({
        matchId: this.$route.params.matchId
      })
      if(result.errorCode === 0) {
        this.matchSummary = result.result
      }
    },
    matchScoreYellowRedList(color, type) {
      if(type === 'home') {
        let homeList = this.matchSummary.homeYellowRedEvents
        let homeYellow = []
        let homeRed = []

        for(var index in homeList) {
          if(homeList[index].eventType === 'yellowcard') {
            homeYellow.push(homeList[index])
          } else {
            homeRed.push(homeList[index])
          }
        }

        if(color === 'yellow') {
          return homeYellow
        } else if(color === 'red') {
          return homeRed
        }
      } else if(type === 'away') {
        let awayList = this.matchSummary.awayYellowRedEvents
        let awayYellow = []
        let awayRed = []

        for(var index in awayList) {
          if(awayList[index].eventType === 'yellowcard') {
            awayYellow.push(awayList[index])
          } else {
            awayRed.push(awayList[index])
          }
        }

        if(color === 'yellow') {
          return awayYellow
        } else if(color === 'red') {
          return awayRed
        }
      }
    },
    checkIfTomorrow(dateString) {
      const inputDate = new Date(dateString);
      const today = new Date();

      // 获取今天的日期并设置时间为零点
      today.setHours(0, 0, 0, 0);

      // 创建明天的日期
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      // 检查输入日期是否与明天匹配
      if (
          inputDate.getFullYear() === tomorrow.getFullYear() &&
          inputDate.getMonth() === tomorrow.getMonth() &&
          inputDate.getDate() === tomorrow.getDate()
      ) {
          return this.$i18n.t('TOMORROW')
      } else {
          return "";
      }
    }
  },
};
</script>

<style scoped>
@media(max-width: 768px) { /* for test */
  .team-red-card-container {
    display: flex;
    width: 24px;
    justify-content: center;
    width: var(--size-icon-medium);
  }
  .team-red-card {
    background: var(--color-background-error-default);
    width: 6px;
    height: 8px;
    margin-right: 2px;
    border-radius: 1px;
    display: block;
    flex-shrink: 0;
  }
  .team-red-card:last-child {
    margin-right: 0;
  }
  .match-detail__content-container {
    /* min-height: 50vh; */
  }
  .match-detail__header-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 16px;
    /* margin-bottom: 0.5rem; */
    /*2rem*/
    padding-bottom: 16px;
    background-color: var(--color-background-default-secondary);
  }
  
  .match-detail__header-info {
    text-align: center;
    margin-bottom: 1rem;
  }
  .match-detail__header-info__match {
    font-size: 0.875rem;
  }
  .match-detail__header-info__country {
    font-size: 0.563rem;
  }
  .match-detail__header-secondary_info {
    /*.match-detail__header-info__date*/
    /* color: var(--color-grey-80);
    font-size: 0.688rem;
    min-height: 0.849rem; */
  
    color: var(--color-text-default-secondary);
  
    font-family: var(--weight-600);
    font-size: 13px;
    font-style: normal;
    line-height: 140%; /* 18.2px */
    margin-bottom: 16px;
    background-color: var(--bg-selected);
    color: var(--color-button-active);
    width: fit-content;
    letter-spacing: 0.52px;
    
    border-radius: 9px;
      padding: 0 8px;
  }
  .match-detail__header-info__date-kh {
    font-family: "Khmer-400";
  }
  .match-detail__header-info__opponent {
    margin-bottom: 0.5rem;
  }
  .match-detail__header-info__match-status {
    font-size: 0.688rem;
    line-height: 1.125rem;
    font-family: var(--weight-400);
    color: var(--bg-selected);
    border: 1px solid var(--bg-selected);
    border-radius: 10px;
    margin-bottom: 0.5rem;
  }
  .match-detail__team-info-wrapper {
    position: relative;
  }
  .match-detail-team-icon {
    width: 56px;
    height: 56px;
  }
  .match-detail__header-info__home-name,
  .match-detail__header-info__away-name {
    width: 7.625rem;
    /* font-size: 0.688rem;
    font-family: var(--weight-400); */
    text-align: center;
    word-break: break-all;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  
    overflow: hidden;
    /* color: var(--color-grey-light); */
    margin-top: 0.25rem;
  
    color: var(--color-text-default-default);
    text-align: center;
  
    font-family: var(--weight-600);
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%; /* 18.2px */
  }
  .match-detail__header-info__home-name:hover,
  .match-detail__header-info__away-name:hover {
    color: var(--primary-500);
  }
  .match-detail__header-info__penatly {
    border-top: 0.1rem solid #35454d;
    margin-top: 0.6rem;
    padding-top: 0.5rem;
  }
  .match-detail__header-info__penatly-title {
    font-size: 11.2px;
    color: var(--color-grey-light);
    margin-bottom: 1rem;
  }
  
  .match-detail__header-info__penatly-label {
    top: 0.8rem; /*0.6rem*/
  
    position: absolute;
    width: 1.625rem; /*2.3rem*/
  }
  .match-detail__header-info__penatly-label.left {
    right: 5.5rem; /*3.4rem*/
  }
  .match-detail__header-info__penatly-label.right {
    left: 5.5rem; /*3.4rem*/
  }
  .match-detail__header-info__score-wrapper {
    font-size: 13px;
    font-family: var(--weight-700);
    width: 8.125rem; /*4.375rem*/
    color: var(--color-text-default-default);
    display: flex;
    flex-direction: column;
    padding-bottom: 24px;
    align-items: center;
  }
  .score-wrapper-not-start.score-wrapper-not-today-tomorrow {
    
    padding-bottom: 0;
  }
  .match-end-score {
    margin-bottom: 30px;
  }
  .match-has-second-status {
    margin-bottom: 0;
  }
  .match-detail__header-info__score-container {
    color: var(--color-text-default-default);
    text-align: center;
    font-family: var(--weight-600);
    font-size: 24px;
    font-style: normal;
    
    line-height: 75%; /* 18px */
    letter-spacing: -0.64px;
    gap: 10px;
  }
  .match-detail__header-info__score {
    width: 2rem;
    text-align: center;
  }
  .match-detail__header-info__score-100 {
    width: 2.8rem;
    text-align: center;
  }
  .match-detail__header-info__score-divider {
    width: 1.5rem;
    display: flex;
    justify-content: center;
    /* margin: 0 0.5rem; */
  }
  .match-detail__header-info__livevideo {
    width: 100%;
    height: auto;
  }
  .penalty-compact-label {
    width: 15px;
    height: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-family: var(--weight-600);
  }
  .penalty-compact-label.left {
    top: -13px;
    left: 10px;
  }
  .penalty-compact-label.right {
    top: -13px;
    right: 10px;
  }
  .skeleton-match-detail__wrapper {
    width: 100%;
    height: 100%;
    padding: 0rem;
    border-radius: 0.5rem;
    box-sizing: border-box;
  }
  /* .skeleton-match-detail__title{
    width: 50%;
    height: 1rem;
    margin-bottom: .25rem;
  }
  .skeleton-match-detail__content{
    width: 100%;
    height: 2rem;
    margin-bottom: 0.5rem;
  } */
  .skeleton-match-detail__score {
    width: calc(100% - 0.6rem);
    height: 1.688rem;
    margin: 0 0.15rem;
    box-sizing: border-box;
    /* margin-bottom: 0.5rem; */
  }
  .youtube-frame {
    width: 100%;
    min-height: 211px;
    margin-bottom: 16px;
    border: 0;
  }
  .youtube-box {
    position: relative;
    width: 100%;
  }
}


</style>

<style>
video:-webikit-full-page-media {
  width: 100%;
}
</style>


<style scoped>
@media(max-width: 768px) { /* for test */

  .match-summary-container {
    background-color: var(--color-background-default-secondary);
    /* border-radius: 0 0 8px 8px; */
  }
  .goal-list {
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
    gap: 16px;
    margin: 0 24px;
    padding: 8px 0;
    border-bottom: 1px dotted var(--color-border-default-default);
  }
  .goal-item {
    /* display: flex; */
    align-items: center;
    gap: 24px;
    font-size: 13px;
    color: var(--color-text-default-secondary);
    text-align: left;
    letter-spacing: .64px;
    font-style: italic;
    flex: 1;
  }
  .goal-item.left {
    text-align: right;
  }
  .goal-child {
  
  }
  .goal-icon {
    width: 24px;
    height: 24px;
  }
  .btn-view-all-card {
    display: flex;
    align-items: center;
    padding: 8px 0;
    margin: 0 24px;
    justify-content: center;
    cursor: pointer;
    border-bottom: 1px dotted var(--color-border-default-default);
    color: var(--color-text-default-default);
  }
  .arrow-icon {
    margin-left: 8px;
    transform: rotate(0deg);
    transition: .5s;
  }
  .arrow-icon.show {
    transform: rotate(180deg);
    transition: .5s;
  }
  .player__row--item--red-card {
    width: 12px;
    height: 16px;
    border-radius: 4px;
    transform: rotate(-20deg);
    background-color: var(--card-red);
  }
  .player__row--item--yellow-card {
    width: 12px;
    height: 16px;
    border-radius: 4px;
    transform: rotate(-20deg);
    background-color: var(--card-yellow);
  }
  .match-yellowred-list {
    display: flex;
    justify-content: center;
    gap: 32px;
    padding-top: 16px;
    
  }
  .match-yellowred-item {
    flex: 1;
  }
  .match-yellowred-item.left {
  }
  .match-yellowred-child {
    gap: 8px;
    display: flex;
    font-size: 13px;
    color: var(--color-text-default-secondary);
    text-align: center;
    letter-spacing: .64px;
    font-style: italic;
  }
  .match-yellowred-child:last-child {
    margin-bottom: 0;
  }
  .match-yellowred-item.left .match-yellowred-child {
    justify-content: right;
  }
  .match__event-type {
    width: 12px;
    height: 12px;
    padding-top: 5px;
    background-size: 12px;
  }
  .match-detail__status {
    color: var(--color-text-default-secondary);
    font-size: 13px;
    margin-top: 8px;
  }
  
  .match-detail__header-info__score-wrapper {
    font-size: 24px;
    letter-spacing: -0.64px;
    font-family: var(--weight-600);
  }
  .future-match-time {
    margin-bottom: 14px;
  }
  .postp {
    margin-bottom: 20px;
  }
}

</style>